import type { AnyObject } from "yup";
import type { QueryParams } from "./types";
import type { NetworkPayload } from "../../../composites";

const resourceUrl = "cards";
const subscriptionsAPI = {
  getSubscriptionsForCard: (
    id: API.CardId,
    dateFilters?: QueryParams | null,
  ): NetworkPayload => {
    let url = `${resourceUrl}/${id}/subscriptions`;
    const hasQueryParams = dateFilters && Object.keys(dateFilters).length > 0;

    // If dateFilters has properties, convert them into a query string.
    if (hasQueryParams) {
      const params = new URLSearchParams(dateFilters as AnyObject).toString();
      url += `?${params}`;
    }

    return {
      url,
      options: {
        method: "GET",
        disableCaching: !dateFilters?.end_date || !dateFilters?.start_date,
      },
    };
  },
};

export default subscriptionsAPI;
